import React from "react";
import { getAuthToken, isValidToken } from "../../security/tokenUtils";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isValidToken(getAuthToken())) {
      console.log("Token is valid, redirecting to default page");
      navigate("/TablaProperties");
    }
  }, []);

  return null;
};

export default Home;
